module.exports = __webpack_public_path__ + "img/printFriendly.ffe0b8dd.svg";